import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/css/bootstrap.css';
import './static/style.css';

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false

var headElement = document.getElementsByTagName("head")[0];

var componentStyleElement = document.createElement("link");
componentStyleElement.type = "text/css";
componentStyleElement.rel = "stylesheet";
componentStyleElement.href = process.env.VUE_APP_HH_CORE_COMPONENTS_URL + "/theme.css?v=" + Date.now();
headElement.appendChild(componentStyleElement);

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
